/* eslint-disable no-case-declarations */
/* eslint-disable indent */
//#region Imports

import { differenceInDays } from 'date-fns';
import moment from 'moment';
import shortid from 'shortid';
import DADOS_SIM from '../../consts/consts';
import MOTOR_FIELDS from '../../consts/motor';
import { RECTANGLE_STATUS_COLOR } from '../../consts/rectangle-color';
import { tratarListaBensRetorno } from '../../session/data-treatement';
import SessionService from '../../session/session-service';
import { verifyStatusBar } from './../../views/lista-bens/services/index';

//#endregion

const motorFields = MOTOR_FIELDS;
const listaBemValues = DADOS_SIM.LISTA_BENS;
const personalizadoFields = DADOS_SIM.PERSONALIZADO;
const questionarioValues = DADOS_SIM.QUESTIONARIO_RESPOSTAS;

/**
 * Types
 */

export const ListaBensTypes = {
    ATUALIZA_LISTA_BENS: 'lista-bens/ATUALIZA_LISTA_BENS',
    ATUALIZA_RECUSA_RESPOSTA: 'lista-bens/ATUALIZA_RECUSA_RESPOSTA',
    ADICIONAR_ITEM_LISTA_BENS: 'lista-bens/ADICIONAR_ITEM_LISTA_BENS',
    ATUALIZA_ITEM_LISTA_BENS: 'lista-bens/ATUALIZA_ITEM_LISTA_BENS',
    ADICIONAR_ITEM_LISTA_CONTEUDO: 'lista-bens/ADICIONAR_ITEM_LISTA_CONTEUDO',
    ATUALIZAR_ITEM_LISTA_CONTEUDO: 'lista-bens/ATUALIZAR_ITEM_LISTA_CONTEUDO',
    ATRIBUIR_VIGENCIA: 'lista-bens/ATRIBUIR_VIGENCIA',
    CLICK_RESPOSTA: 'lista-bens/CLICK_RESPOSTA',
    DUPLICAR_ITEM_LISTA_BENS: 'lista-bens/DUPLICAR_ITEM_LISTA_BENS',
    EXCLUIR_ITEM_LISTA_BENS: 'lista-bens/EXCLUIR_ITEM_LISTA_BENS',
    EXCLUIR_ITEM_LISTA_CONTEUDO: 'lista-bens/EXCLUIR_ITEM_LISTA_CONTEUDO',
    MINIMO_MAXIMO_VIGENCIA: 'lista-bens/MINIMO_MAXIMO_VIGENCIA',
    MINIMO_MAXIMO_VIGENCIA_SUCCESS: 'lista-bens/MINIMO_MAXIMO_VIGENCIA_SUCCESS',
    MINIMO_MAXIMO_VIGENCIA_FAILURE: 'lista-bens/MINIMO_MAXIMO_VIGENCIA_FAILURE',
    SET_TIPO_VIGENCIA_OPTIONS: 'lista-bens/SET_TIPO_VIGENCIA_OPTIONS',
    POPULAR_RESPOSTAS_PADROES: 'lista-bens/POPULAR_RESPOSTAS_PADROES',
    RESET_MSG_ERRO: 'lista-bens/RESET_MSG_ERRO',
    RESET: 'lista-bens/RESET',
    POPULAR_DATA_STORAGE: 'lista-bens/DATA_FROM_STORAGE',
    SEND_LISTA_BENS: 'lista-bens/SEND_LISTA_BENS',
    SEND_LISTA_BENS_SUCCESS: 'lista-bens/SEND_LISTA_BENS_SUCCESS',
    SEND_LISTA_BENS_FAILURE: 'lista-bens/SEND_LISTA_BENS_FAILURE',
    ATUALIZA_VERIFICA_EDICAO_LISTA_BENS: 'lista-bens/ATUALIZA_VERIFICA_EDICAO_LISTA_BENS',
    COLLAPSE_BOX: 'lista-bens/COLLAPSE_BOX',
    STATUS_RECTANGLE: 'lista-bens/STATUS_RECTANGLE',
    SET_ERROR_MESSAGE: 'lista-bens/SET_ERROR_MESSAGE'
};

/**
 * Reducer
 */
let INITIAL_STATE = {
    listaBens: [],
    [listaBemValues.TIPO_VIGENCIA]: null,
    [listaBemValues.DATA_INICIO_VIGENCIA]: null,
    [listaBemValues.DATA_FIM_VIGENCIA]: null,
    [listaBemValues.TEMPO_VIGENCIA]: null,
    codigoAcesso: null,
    restricaoMinimaDataInicial: null,
    restricaoMaximaDataInicial: null,
    intervaloMinimoVigencia: null,
    intervaloMaximoVigencia: null,
    errorMsg: '',
    errorMsgVigencia: '',
    loadingTelaSimular: false,
    verificaEdicao: false,
    verificaEdicaoId: null
};

export function listaBensReducer(state = INITIAL_STATE, action) {
    let novoBem = null;
    let novoBemId = null;
    let conteudoId = null;
    let novoConteudo = null;
    let novaListaBens = state.listaBens;

    switch (action.type) {
        case ListaBensTypes.RESET: {
            INITIAL_STATE.listaBens = [];
            return { ...INITIAL_STATE };
        }
        case ListaBensTypes.POPULAR_DATA_STORAGE: {
            let dataInicioVigencia;
            let dataFimVigencia;
            let tempoVigencia;
            if (action.payload.dados[listaBemValues.TIPO_VIGENCIA] === 'Seletiva') {
                dataInicioVigencia = moment(action.payload.dados[listaBemValues.DATA_INICIO_VIGENCIA]).toDate();
                dataFimVigencia = moment(action.payload.dados[listaBemValues.DATA_FIM_VIGENCIA]).toDate();
                tempoVigencia = differenceInDays(dataFimVigencia, dataInicioVigencia) + ' dias';
            } else {
                dataInicioVigencia = null;
                dataFimVigencia = null;
                tempoVigencia = null;
            }
            return {
                ...state,
                listaBens: action.payload.dados.listaBens,
                [listaBemValues.DATA_INICIO_VIGENCIA]: dataInicioVigencia,
                [listaBemValues.DATA_FIM_VIGENCIA]: dataFimVigencia,
                [listaBemValues.TEMPO_VIGENCIA]: tempoVigencia,
                [listaBemValues.TIPO_VIGENCIA]: action.payload.dados[listaBemValues.TIPO_VIGENCIA]
            };
        }
        case ListaBensTypes.ATUALIZA_LISTA_BENS:
            return {
                ...state,
                listaBens: action.payload.novaListaBens
            };

        case ListaBensTypes.ATUALIZA_RECUSA_RESPOSTA:
            return {
                ...state,
                listaBens: state.listaBens.map((bem) => {
                    if (bem.id !== action.payload.bemId) {
                        return bem;
                    }

                    return (bem = {
                        ...bem,
                        [listaBemValues.RESPOSTA_RECUSADA]: action.payload.recusa
                    });
                })
            };

        case ListaBensTypes.ADICIONAR_ITEM_LISTA_BENS:
            novoBem = null;
            novaListaBens = state.listaBens ? state.listaBens : [];
            novoBem = action.payload.item;
            novoBem = {
                ...novoBem,
                id: shortid.generate(),
                [listaBemValues.COTACAO_CONTEUDO]: [],
                [listaBemValues.QUESTIONARIO_RESPOSTAS]: []
            };
            return {
                ...state,
                listaBens: [...state.listaBens, novoBem]
            };

        case ListaBensTypes.ATUALIZA_ITEM_LISTA_BENS: {
            novoBem = action.payload.item;

            const novaListaBens = state.listaBens.map((bem) => {
                if (bem.id !== novoBem.id) {
                    return bem;
                }
                const bemAtualizado = {
                    ...bem,
                    ...novoBem
                };

                if (bem[listaBemValues.TIPO_BEM] !== novoBem[listaBemValues.TIPO_BEM]) {
                    bemAtualizado[listaBemValues.RETANGULO_LISTA_BENS] = RECTANGLE_STATUS_COLOR.LARANJA;
                } else {
                    bemAtualizado[listaBemValues.RETANGULO_LISTA_BENS] = verifyStatusBar(bemAtualizado)
                        ? RECTANGLE_STATUS_COLOR.VERDE
                        : RECTANGLE_STATUS_COLOR.LARANJA;
                }

                return bemAtualizado;
            });

            return {
                ...state,
                listaBens: novaListaBens
            };
        }
        case ListaBensTypes.DUPLICAR_ITEM_LISTA_BENS:
            novoBemId = action.payload.item;
            let bemDuplicado = novaListaBens.find((el) => el.id === novoBemId);
            let listaConteudoDuplicado;

            // Verifica se o bem duplicado eh do tipo "Benfeitoria" para poder duplicar tambem a lista de conteudos
            if (bemDuplicado && bemDuplicado[listaBemValues.ID_TIPO_BEM] === 1)
                listaConteudoDuplicado = [...bemDuplicado[listaBemValues.COTACAO_CONTEUDO]];

            bemDuplicado = {
                ...bemDuplicado,
                id: shortid.generate(),
                [listaBemValues.COTACAO_CONTEUDO]: listaConteudoDuplicado
            };
            return {
                ...state,
                listaBens: [...state.listaBens, bemDuplicado]
            };

        case ListaBensTypes.EXCLUIR_ITEM_LISTA_BENS:
            let idBem = action.payload[listaBemValues.ID_BEM];

            // Filtra a listaBens para expurgar o bem a ser excluido
            let novaListaBensExcluir = state.listaBens.filter((element) => element.id !== idBem);

            return {
                ...state,
                listaBens: novaListaBensExcluir
            };

        case ListaBensTypes.ADICIONAR_ITEM_LISTA_CONTEUDO:
            novoConteudo = action.payload.conteudo;

            return {
                ...state,
                listaBens: novaListaBens.map((bem) => {
                    if (bem.id !== action.payload.idListaBem) {
                        return bem;
                    }

                    novoConteudo = {
                        id: shortid.generate(),
                        ...novoConteudo
                    };

                    return (bem = {
                        ...bem,
                        [listaBemValues.COTACAO_CONTEUDO]: [...bem[listaBemValues.COTACAO_CONTEUDO], novoConteudo]
                    });
                })
            };

        case ListaBensTypes.ATUALIZAR_ITEM_LISTA_CONTEUDO:
            novoConteudo = action.payload.conteudo;
            conteudoId = action.payload.idConteudo;

            novoConteudo = {
                ...novoConteudo,
                id: conteudoId
            };
            // Verifica qual item da listaBens a ser alterado o conteudo da cotacaoConteudos do item
            novaListaBens.forEach((el) => {
                if (el.id === action.payload.idListaBem) {
                    // Procura pelo conteudo a ser atualizado e remove-o para adicionar o novo conteudo
                    el.cotacaoConteudos.forEach((element, index) => {
                        if (element.id === conteudoId) {
                            el.cotacaoConteudos.splice(index, 1, novoConteudo);
                        }
                    });
                }
            });
            return {
                ...state,
                listaBens: novaListaBens
            };

        case ListaBensTypes.EXCLUIR_ITEM_LISTA_CONTEUDO:
            return {
                ...state,
                listaBens: state.listaBens.map((bem) => {
                    if (bem.id !== action.payload.idBem) {
                        return bem;
                    }

                    const novaListaConteudo = bem[listaBemValues.COTACAO_CONTEUDO].filter((conteudo) => {
                        if (conteudo.id !== action.payload.idConteudo) {
                            return conteudo;
                        } else return false;
                    });

                    return (bem = {
                        ...bem,
                        [listaBemValues.COTACAO_CONTEUDO]:
                            !novaListaConteudo || novaListaConteudo.length === 0 ? [] : novaListaConteudo
                    });
                })
            };

        case ListaBensTypes.ATRIBUIR_VIGENCIA: {
            let nomeTipoVigencia = action.payload[listaBemValues.TIPO_VIGENCIA];
            let inicioVigencia = action.payload[listaBemValues.DATA_INICIO_VIGENCIA];
            let fimVigencia = action.payload[listaBemValues.DATA_FIM_VIGENCIA];
            let qtTempoVigencia;

            if (nomeTipoVigencia === 'Padrão') {
                inicioVigencia = null;
                fimVigencia = null;
                qtTempoVigencia = '365 dias';
            } else qtTempoVigencia = differenceInDays(fimVigencia, inicioVigencia).toString() + ' dias';

            return {
                ...state,
                [listaBemValues.TIPO_VIGENCIA]: nomeTipoVigencia,
                [listaBemValues.DATA_INICIO_VIGENCIA]: inicioVigencia,
                [listaBemValues.DATA_FIM_VIGENCIA]: fimVigencia,
                [listaBemValues.TEMPO_VIGENCIA]: qtTempoVigencia
            };
        }
        case ListaBensTypes.SET_TIPO_VIGENCIA_OPTIONS: {
            return {
                ...state,
                tipoVigenciaOptions: action.payload.options
            };
        }
        case ListaBensTypes.CLICK_RESPOSTA:
            let newLista = novaListaBens;
            newLista = newLista.map((bem) =>
                bem.id === action.payload.listaBensId
                    ? {
                          ...bem,
                          [listaBemValues.QUESTIONARIO_RESPOSTAS]: [
                              ...bem[listaBemValues.QUESTIONARIO_RESPOSTAS].map((resp) =>
                                  resp[questionarioValues.ID_REDIS] === action.payload.respostaId
                                      ? { ...resp, [questionarioValues.RESPOSTA]: action.payload.resposta }
                                      : resp
                              )
                          ]
                      }
                    : bem
            );
            return { ...state, listaBens: newLista };

        case ListaBensTypes.POPULAR_RESPOSTAS_PADROES: {
            const { listaBens } = state;

            if (!listaBens) return state;

            let bem = listaBens.find((bem) => bem.id === action.payload.listaBensId);
            if (bem && bem[listaBemValues.QUESTIONARIO_RESPOSTAS].length > 0) {
                return { ...state };
            }

            let novaLista = listaBens.map((bem) =>
                bem.id === action.payload.listaBensId
                    ? { ...bem, [listaBemValues.QUESTIONARIO_RESPOSTAS]: action.payload.listaRespostasPadroes }
                    : bem
            );
            return { ...state, listaBens: novaLista };
        }
        case ListaBensTypes.SEND_LISTA_BENS:
            return {
                ...state,
                loadingTelaSimular: true,
                errorMsg: ''
            };
        case ListaBensTypes.SEND_LISTA_BENS_SUCCESS:
            const listaAtualizada = tratarListaBensRetorno(action.payload.objResponse);
            SessionService.saveSession({
                [personalizadoFields.CALCULAR_PERSONALIZADO]: false,
                [motorFields.RESULTADO_CALCULO]: null,
                [listaBemValues.CODIGO_COTACAO]: action.payload.objResponse[listaBemValues.CODIGO_COTACAO],
                listaBensRetorno: listaAtualizada
            });

            return {
                ...state,
                codigoAcesso: action.payload.objResponse['codigoAcesso'],
                tipoCotacao: action.payload.objResponse['tipoCotacao'],
                [listaBemValues.CODIGO_COTACAO]: action.payload.objResponse[listaBemValues.CODIGO_COTACAO],
                listaBensRetorno: listaAtualizada,
                errorMsg: 'OK',
                loadingTelaSimular: false
            };

        case ListaBensTypes.SEND_LISTA_BENS_FAILURE:
            return {
                ...state,
                errorMsg: action.payload.errorMsg,
                loadingTelaSimular: false
            };

        case ListaBensTypes.MINIMO_MAXIMO_VIGENCIA: {
            return {
                ...state,
                loadingMinMaxVigencia: true
            };
        }
        case ListaBensTypes.MINIMO_MAXIMO_VIGENCIA_SUCCESS:
            return {
                ...state,
                restricaoMinimaDataInicial: action.payload.data.restricaoMinimaDataInicial,
                restricaoMaximaDataInicial: action.payload.data.restricaoMaximaDataInicial,
                intervaloMinimoVigencia: action.payload.data.intervaloMinimoVigencia,
                intervaloMaximoVigencia: action.payload.data.intervaloMaximoVigencia,
                loadingMinMaxVigencia: false
            };
        case ListaBensTypes.MINIMO_MAXIMO_VIGENCIA_FAILURE:
            return { ...state, errorMsg: action.payload.errorMsg, loadingMinMaxVigencia: false };
        case ListaBensTypes.RESET_MSG_ERRO:
            return { ...state, errorMsg: '' };
        case ListaBensTypes.ATUALIZA_VERIFICA_EDICAO_LISTA_BENS:
            return { ...state, verificaEdicao: action.payload.estadoBtn, verificaEdicaoId: action.payload.id };
        case ListaBensTypes.COLLAPSE_BOX:
            novaListaBens = state.listaBens;

            return {
                ...state,
                listaBens: novaListaBens.map((bem) => {
                    if (bem.id !== action.payload.id) {
                        return bem;
                    }

                    return (bem = {
                        ...bem,
                        isCollapse: action.payload.collapseState,
                        iconNameCollapse: action.payload.collapseState ? 'angle double down' : 'angle double up'
                    });
                })
            };

        case ListaBensTypes.STATUS_RECTANGLE:
            novaListaBens = state.listaBens;

            novaListaBens.forEach((bem) => {
                if (bem.id === action.payload.id) {
                    bem.statusRectangleColor = action.payload.cor;
                }
            });

            return { ...state, [listaBemValues.THIS]: novaListaBens };
        case ListaBensTypes.SET_ERROR_MESSAGE: {
            return { ...state, errorMsg: action.payload.errorMsg };
        }
        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    atualizaListaBens: (novaListaBens) => ({
        type: ListaBensTypes.ATUALIZA_LISTA_BENS,
        payload: { novaListaBens }
    }),
    atualizaRecusaResposta: (bemId, recusa) => ({
        type: ListaBensTypes.ATUALIZA_RECUSA_RESPOSTA,
        payload: { bemId, recusa }
    }),
    adicionaItemListaBens: (item) => ({
        type: ListaBensTypes.ADICIONAR_ITEM_LISTA_BENS,
        payload: { item }
    }),
    atualizaItemListaBens: (item) => ({
        type: ListaBensTypes.ATUALIZA_ITEM_LISTA_BENS,
        payload: { item }
    }),
    duplicarItemListaBens: (item) => ({
        type: ListaBensTypes.DUPLICAR_ITEM_LISTA_BENS,
        payload: { item }
    }),
    excluiItemListaBens: (idBem) => ({
        type: ListaBensTypes.EXCLUIR_ITEM_LISTA_BENS,
        payload: { idBem }
    }),
    adicionaItemListaConteudo: (idListaBem, conteudo) => ({
        type: ListaBensTypes.ADICIONAR_ITEM_LISTA_CONTEUDO,
        payload: { idListaBem, conteudo }
    }),
    atualizaItemListaConteudo: (idListaBem, conteudo, idConteudo) => ({
        type: ListaBensTypes.ATUALIZAR_ITEM_LISTA_CONTEUDO,
        payload: { idListaBem, conteudo, idConteudo }
    }),
    excluiItemListaConteudo: (idBem, idConteudo) => ({
        type: ListaBensTypes.EXCLUIR_ITEM_LISTA_CONTEUDO,
        payload: { idBem, idConteudo }
    }),
    atribuirVigencia: (inicioVigencia, fimVigencia, nomeTipoVigencia) => ({
        type: ListaBensTypes.ATRIBUIR_VIGENCIA,
        payload: { inicioVigencia, fimVigencia, nomeTipoVigencia }
    }),
    clickResposta: (listaBensId, novoQuestionario) => ({
        type: ListaBensTypes.CLICK_RESPOSTA,
        payload: { listaBensId, novoQuestionario }
    }),
    popularRespostas: (listaBensId, listaRespostasPadroes) => ({
        type: ListaBensTypes.POPULAR_RESPOSTAS_PADROES,
        payload: { listaBensId, listaRespostasPadroes }
    }),
    popularDataStorage: (dados) => ({
        type: ListaBensTypes.POPULAR_DATA_STORAGE,
        payload: { dados }
    }),
    sendListaBens: (objEnvio) => ({
        type: ListaBensTypes.SEND_LISTA_BENS,
        payload: { objEnvio }
    }),
    sendListaBensSuccess: (objResponse) => ({
        type: ListaBensTypes.SEND_LISTA_BENS_SUCCESS,
        payload: { objResponse }
    }),
    sendListaBensFailure: (errorMsg) => ({
        type: ListaBensTypes.SEND_LISTA_BENS_FAILURE,
        payload: { errorMsg }
    }),
    resetMsgErro: () => ({
        type: ListaBensTypes.RESET_MSG_ERRO
    }),
    minimoMaximoVigencia: (tipoCotacao, codigoCotacao) => ({
        type: ListaBensTypes.MINIMO_MAXIMO_VIGENCIA,
        payload: { tipoCotacao, codigoCotacao }
    }),
    minimoMaximoVigenciaSuccess: (data) => ({
        type: ListaBensTypes.MINIMO_MAXIMO_VIGENCIA_SUCCESS,
        payload: { data }
    }),
    minimoMaximoVigenciaFailure: (errorMsg) => ({
        type: ListaBensTypes.MINIMO_MAXIMO_VIGENCIA_FAILURE,
        payload: { errorMsg }
    }),
    setTipoVigenciaOptions: (options) => ({
        type: ListaBensTypes.SET_TIPO_VIGENCIA_OPTIONS,
        payload: { options }
    }),
    reset: () => ({
        type: ListaBensTypes.RESET
    }),
    atualizaVerificaEdicaoListaBens: (estadoBtn, id) => ({
        type: ListaBensTypes.ATUALIZA_VERIFICA_EDICAO_LISTA_BENS,
        payload: { estadoBtn, id }
    }),
    atualizaCollapseBox: (id, collapseState) => ({
        type: ListaBensTypes.COLLAPSE_BOX,
        payload: { id, collapseState }
    }),
    atualizaRetanguloStatus: (id, cor) => ({
        type: ListaBensTypes.STATUS_RECTANGLE,
        payload: { id, cor }
    }),
    setErrorMsg: (errorMsg) => ({
        type: ListaBensTypes.SET_ERROR_MESSAGE,
        payload: { errorMsg }
    })
};
